<template>
  <div class="BoxFront">
    <div class="contentFront">
      <p style="font-size: 1rem; font-weight: bold">NOTA DE COMPRA</p>
      <div class="formFront">
        <InputSelect
          label="Natureza operação"
          :items="allNatures"
          valueField="id"
          textField="descricao"
          :dataSelect.sync="dataPurchase.idNatureOp"
          :openCreateModal="() => openModals('modalNatures')"
          ref="refNop"
        />

        <div class="selectPlus">
          <label class="fixedSelect"
            >Selecione CFOP <span style="color: rgb(115, 0, 0)">*</span></label
          >
          <b-form-select
            class="borderInput shadow-none"
            :options="cfop"
            v-model="dataPurchase.cfop"
            size="sm"
          >
          </b-form-select>
        </div>
        <span class="alertModal"
          >*É necessário selecionar o CFOP antes de importar o XML</span
        >
        <div class="rowContent">
          <b-form-input
            hidden
            v-model="dataPurchase.id"
            class="col-sm-1"
          ></b-form-input>

          <div class="input-group">
            <Input
              style="width: 100%"
              label="Data Compra"
              type="date"
              labelFixed
              :dataInput.sync="dataPurchase.dataCompra"
              :isInvalidInput="invalidFieldsPurchase?.dataCompra || ''"
              @clearInvalidInput="clearInvalidFields('dataCompra')"
              ref="dataCompra"
            />
          </div>

          <div class="input-group">
            <input
              required
              class="input borderInput"
              type="number"
              v-model="dataPurchase.numeroNfe"
            />
            <label class="user-label"> Nº NF-e </label>
          </div>

          <div class="input-group">
            <input
              required
              class="input borderInput"
              type="number"
              v-model="dataPurchase.modeloNfe"
            />
            <label class="user-label"> Modelo </label>
          </div>
          <div class="input-group">
            <input
              required
              class="input borderInput"
              type="number"
              v-model="dataPurchase.serieNfe"
            />
            <label class="user-label"> Serie </label>
          </div>
        </div>

        <div>
          <InputSelect
            label="Fornecedor"
            :items="allSupplier"
            valueField="id"
            textField="razaoSocial"
            :dataSelect.sync="dataPurchase.idFornecedor"
            :isInvalidInput="invalidFieldsPurchase?.idFornecedor || ''"
            :openCreateModal="() => openModals('modalCreateSupplier')"
            @clearInvalidInput="clearInvalidFields('idFornecedor')"
            ref="idFornecedor"
          />
        </div>

        <div class="rowObservation">
          <div class="input-group-ob">
            <input
              required
              class="input borderInput"
              v-model="dataPurchase.dadosAdicionais"
            />
            <label class="user-label"> Descrição </label>
          </div>
        </div>

        <div
          style="
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0.5rem 0 0 0;
          "
        >
          <div style="width: 250px">
            <Tabs
              noPadding
              fontSizeTitle="10px"
              gapTabItem="0"
              :tabs="tabs"
              :tabSelected="tabSelected"
              :actionToAlterTab="actionToAlterTab"
              @activeIdxTab="handleSelectTab"
            >
              <template v-slot:normal> </template>

              <template v-slot:perticides> </template>
            </Tabs>
          </div>
        </div>

        <div v-if="!tabSelected">
          <InputProducts
            key="prod"
            label="Produto"
            typeFilter="itens"
            :isEdit="purchaseMoviment.idProduto"
            :dataInput.sync="purchaseMoviment.idProduto"
            :onSearch="fillProductsComboBoxWithPaginate"
            :openCreateModal="
              () =>
                handleModalCreateProduct(
                  'modal-1',
                  purchaseMoviment.idProduto
                )
            "
            :clearSelected="toggleClearSelect"
            :searchFields="['nome', 'codRef']"
            :typeSlotProps="{ fistValue: 'nome', secondValue: '' }"
            :isInvalidInput="invalidFieldsMoviment?.idProduto || ''"
            @selectItem="selectProductSetDefaultValue($event)"
            @clearInvalidInput="
              clearInvalidFields('idProduto', 'invalidFieldsMoviment')
            "
          />
        </div>

        <div v-else>
          <InputProducts
            key="agro"
            label="Agrotóxicos"
            typeFilter="itens"
            :isEdit="purchaseMoviment.agrotoxico.idAgrotoxico"
            :dataInput.sync="purchaseMoviment.agrotoxico.idAgrotoxico"
            :onSearch="fillPesticidesComboBoxWithPaginate"
            :clearSelected="toggleClearSelect"
            :searchFields="!tabSelected ? ['nome', 'codRef'] : ['nomeComum']"
            :isInvalidInput="invalidFieldsMoviment?.idAgrotoxico || ''"
            @selectItem="selectProductSetDefaultValue($event)"
            @clearInvalidInput="
              clearInvalidFields('idAgrotoxico', 'invalidFieldsMoviment')
            "
          />
        </div>

        <div class="rowContent">
          <div class="input-group">
            <Input
              style="width: 100%"
              label="Quantidade"
              type="number"
              labelFixed
              :dataInput.sync="purchaseMoviment.quantidade"
              :isInvalidInput="invalidFieldsMoviment?.quantidade || ''"
              @clearInvalidInput="
                clearInvalidFields('quantidade', 'invalidFieldsMoviment')
              "
              ref="quantidade"
            />
          </div>

          <InputMoney
            label="Valor"
            type="text"
            :dataInput.sync="purchaseMoviment.valorUnitario"
            :isInvalidInput="invalidFieldsMoviment?.valorUnitario || ''"
            @clearInvalidInput="
              clearInvalidFields('valorUnitario', 'invalidFieldsMoviment')
            "
            ref="valorUnitario"
          />

          <Input
            label="Estoque"
            type="text"
            :dataInput.sync="estoque"
            ref="estoque"
            :class="`inputDisabled`"
          />
        </div>

        <div class="rowContent" v-if="tabSelected">
          <InputSelect
            style="width: 100%"
            label="Embalagens"
            valueField="descricao"
            textField="descricao"
            :items="listEmbs"
            :dataSelect.sync="purchaseMoviment.agrotoxico.embalagem"
            :enableIconCreate="false"
            :isInvalidInput="invalidFieldsMoviment?.embalagem || ''"
            @clearInvalidInput="
              clearInvalidFields('embalagem', 'invalidFieldsMoviment')
            "
            @selectedIten="handleAssingEmb"
            ref="embalagem"
          />

          <Input
            style="width: 100%"
            label="Nª Lote"
            type="text"
            :dataInput.sync="purchaseMoviment.agrotoxico.lote"
            ref="lote"
          />
        </div>
      </div>

      <div class="content-form-btn">
        <b-button @click="addProduct" class="form-btn">
          Adicionar Produto
          <b-icon-arrow-right-short></b-icon-arrow-right-short
        ></b-button>
      </div>
    </div>
    <div class="contentSketch">
      <p style="font-size: 1rem; font-weight: bold; padding: 0 25px">
        PRODUTOS ADICIONADOS
      </p>
      <div class="productsDesktop">
        <table style="width: 100%">
          <thead style="border-bottom: 2px solid #d5d3d3; font-size: 12px">
            <tr>
              <th style="width: 40%">Nome</th>
              <th style="width: 10%">Quant</th>
              <th style="width: 15%">Vl. Unitário</th>
              <th style="width: 15%">Vl. Total</th>
              <th style="width: 10%">Ações</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="item in productsListGrid"
              :key="item.id"
              class="rowProduct"
            >
              <td style="width: 40%">{{ item.nome }}</td>
              <td style="width: 10%">{{ item.quantidade }}</td>
              <td style="width: 15%">
                {{
                  item.valorUnitario.toLocaleString("pt-br", {
                    style: "currency",
                    currency: "BRL",
                  })
                }}
              </td>
              <td style="width: 15%">
                {{
                  (item.valorUnitario * item.quantidade).toLocaleString(
                    "pt-br",
                    {
                      style: "currency",
                      currency: "BRL",
                    }
                  )
                }}
              </td>
              <td style="width: 10%">
                <b-icon-x-circle
                  scale="1.3"
                  class="trashDelete"
                  @click="deleteProductOfPurchase(item)"
                ></b-icon-x-circle>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      
      <div class="productsMobile">
        <div
          v-if="!productsListGrid || !productsListGrid.length"
          class="emptyList"
        >
          Nenhum produto adicionado
        </div>
        <div
          v-for="item in productsListGrid"
          :key="item.id"
          class="productCard"
        >
          <div class="productHeader">
            <div class="productName">{{ item.nome }}</div>
            <b-icon-x-circle
              scale="1.3"
              class="trashDelete"
              @click="deleteProductOfPurchase(item)"
            ></b-icon-x-circle>
          </div>

          <div class="productMeta">
            <div class="metaItem">
              <span class="metaLabel">Quantidade</span>
              <span class="metaValue">{{ item.quantidade }}</span>
            </div>
            <div class="metaItem">
              <span class="metaLabel">Vl. Unitário</span>
              <span class="metaValue">
                {{
                  item.valorUnitario.toLocaleString("pt-br", {
                    style: "currency",
                    currency: "BRL",
                  })
                }}
              </span>
            </div>
          </div>

          <div class="productFooter">
            <span class="metaLabel">Vl. Total</span>
            <span class="metaValue">
              {{
                (item.valorUnitario * item.quantidade).toLocaleString(
                  "pt-br",
                  {
                    style: "currency",
                    currency: "BRL",
                  }
                )
              }}
            </span>
          </div>
        </div>
      </div>
      <div class="styleTotal">
        <div v-if="dataPurchase.chaveNfe || Number(dataPurchase.valorNfe) > 0">
          <span>VALOR TOTAL NOTA: </span>
          <span> {{ valorNfeFormatado }} </span>
        </div>

        <div>
          <span>VALOR TOTAL PRODUTOS: </span>
          <span>{{ this.amount }}</span>
        </div>
      </div>
      <div class="content-sketch-btn">
        <button
          @click="clearAll"
          class="sketch-btn"
          style="background: #fbfbfb; color: black; border: 1px solid gray"
        >
          Novo <b-icon-arrow-clockwise class="ml-1"></b-icon-arrow-clockwise>
        </button>
        <button @click="saveAndUpdate" class="sketch-btn">
          <span>Salvar</span>
        </button>
      </div>
    </div>
    <b-modal id="modal-1" hide-footer hide-header size="lg">
      <button class="closeModal" @click="$bvModal.hide('modal-1')">
        <b-icon-x scale="1.3"></b-icon-x>
      </button>

      <Products
        :idProductFromSearch="idProductFromSearch"
        @getAllProducts="fillProductsComboBoxWithPaginate"
      />
    </b-modal>
    <ModalCreateSupplier @getAllNewSupplier="getAllSuppliers" />
    <ModalImportXml
      @idSupplierForSelectBox="idSupplier = $event"
      @dataProduct="dataProduct = $event"
      @modalIdForPurchase="modalIdForPurchase = $event"
      @valorNfe="dataPurchase.valorNfe = $event"
      :cfopSelect="cfopSelect"
      :payloadFromDfe="payloadFromDfe"
      :listEmbs="listEmbs"
    />
    <ModalCreateNatureOps @getNewNature="getAllNatures" />
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";

import ModalImportXml from "./Modal-Import-Xml.vue";
import ServiceSupplier from "../../services/serviceSupplier";
import ModalCreateSupplier from "../Modals/ModalCreateSupplier.vue";

import Products from "../Products/Products.vue";
import ModalCreateNatureOps from "../../components/Modals/ModalCreateNatureOps.vue";
import Input from "../UI/CustomInputs/Input.vue";
import InputMoney from "../UI/CustomInputs/InputMoney.vue";
import InputSelect from "../../components/UI/CustomInputs/InputSelect.vue";
import InputProducts from "../UI/CustomInputs/InputProducts.vue";

import Tabs from "../UI/Tabs/Tab.vue";

import ServicePurchase from "../../services/servicePurchase";
import ServiceProductsPurchase from "../../services/serviceProductsPurchase";
import serviceNatureOps from "../../services/serviceNatureOps";
import ServiceProducts from "../../services/serviceProducts";
import ServiceCompendio from "../../services/serviceCompendio";

import {
  INITIAL_STATE_PURCHASE,
  INVALID_FIELDS_PURCHASE,
} from "../../initialStates/purchase";
import {
  INITIAL_STATE_PURCHASE_MOVIMENT,
  INVALID_FIELDS_PURCHASE_MOVIMENT,
} from "../../initialStates/purchaseMoviment";

import { ValidatePurchase } from "../../validators/purchase/index";
import { ValidatePurchaseMoviment } from "../../validators/purchaseMoviment/index";
import { HandleErrors } from "../../utils/handleErrors";
import { removeReference } from "../../utils/removeReference";
import { cfop } from "../../common/index";

export default {
  components: {
    Products,
    ModalCreateSupplier,
    ModalCreateNatureOps,
    ModalImportXml,
    Input,
    InputMoney,
    InputSelect,
    InputProducts,
    Tabs,
  },
  props: {
    dataEditPurchase: {
      type: Object,
    },
    payloadFromDfe: {
      type: Object,
    },
  },
  data() {
    return {
      idProductFromSearch: "",
      getAllProducts: null,
      products: [],
      allSupplier: [],
      amount: 0,
      cfop: cfop,
      cfopSelect: "",
      dataPurchase: removeReference(INITIAL_STATE_PURCHASE),
      invalidFieldsPurchase: removeReference(INVALID_FIELDS_PURCHASE),
      purchaseMoviment: removeReference(INITIAL_STATE_PURCHASE_MOVIMENT),
      invalidFieldsMoviment: removeReference(INVALID_FIELDS_PURCHASE_MOVIMENT),
      idSupplier: "",
      idSupplierForSelectBox: "",
      dataProduct: [],
      modalIdForPurchase: "",
      estoque: 0,
      selectedProductName: "",
      productsListGrid: [],
      allNatures: [],
      toggleClearSelect: false,
      actionToAlterTab: false,
      tabSelected: 0,
      tabs: [
        { name: "normal", text: "Normal" },
        { name: "perticides", text: "Agrotoxíco" },
      ],
      listEmbs: [],
    };
  },

  methods: {
    ...mapMutations(["SET_DATA_SEARCH_FROM_PURCHASE"]),
    async fillProductsComboBoxWithPaginate(id, q, filterType, page) {
      try {
        const typeProduct = !this.tabSelected ? "normal" : "agrotoxico";

        return await ServiceProducts.fillComboBoxWithPaginate(
          id,
          q,
          filterType,
          page,
          typeProduct
        );
      } catch (error) {
        this.$toast.open({
          message:
            error?.response?.data?.message ||
            "Ocorreu um problema ao listar os produtos",
          type: "info",
        });
      }
    },

    async fillPesticidesComboBoxWithPaginate(
      id,
      q,
      filterType,
      page,
      typeProduct
    ) {
      try {
        const { data } = await ServiceCompendio.combobox(
          id,
          q,
          filterType,
          page,
          typeProduct
        );

        return data?.map((agro) => {
          return {
            id: agro.id,
            nome: agro.nomeComum,
            registro: agro.registro,
          };
        });
      } catch (error) {
        this.$toast.open({
          message:
            error?.response?.data?.message ||
            "Ocorreu um problema ao listar os produtos",
          type: "info",
        });

        return;
      }
    },

    async saveAndUpdate(showToast = true) {
      if (!this.handleValidate()) return true;

      const result =
        this.dataPurchase.id !== ""
          ? await this.updatePurchase(showToast)
          : await this.savePurchase();

      return result;
    },

    async savePurchase() {
      try {
        const { id } = await ServicePurchase.savePurchase(this.dataPurchase);
        this.dataPurchase.id = id;
        this.purchaseMoviment.idCompra = id;

        this.$toast.open({
          message: "Nova compra registrada com sucesso!",
          type: "success",
        });
      } catch (error) {
        const message = error?.response?.data?.message;

        const typeError = HandleErrors(
          error?.response?.data?.message === "Validation failed"
            ? error?.response?.data?.erros
            : error?.response?.data?.message
        );

        if (message && message.includes("NOT_ALLOWED"))
          this.$toast.open({
            message: message.split(":")[1],
            type: "info",
          });
        else if (typeError && Object.keys(typeError).length)
          this.$toast.open({
            message: typeError.message,
            type: "info",
          });
        else
          this.$toast.open({
            message: `${error.response.data.message}`,
            type: "warning",
          });

        return error;
      }
    },

    async updatePurchase(showToast = true) {
      try {
        const { data } = await ServicePurchase.updatePurchase(
          this.dataPurchase.id,
          this.dataPurchase
        );

        if (showToast)
          this.$toast.open({
            message: "Compra atualizada com sucesso!",
            type: "success",
          });
        return data;
      } catch (error) {
        const message = error?.response?.data?.message;

        const typeError = HandleErrors(
          error?.response?.data?.message === "Validation failed"
            ? error?.response?.data?.erros
            : error?.response?.data?.message
        );

        if (message && message.includes("NOT_ALLOWED"))
          this.$toast.open({
            message: message.split(":")[1],
            type: "info",
          });
        else if (typeError && Object.keys(typeError).length)
          this.$toast.open({
            message: typeError.message,
            type: "info",
          });
        else
          this.$toast.open({
            message: `${error.response.data.message}`,
            type: "warning",
          });

        return error;
      }
    },

    async addProduct() {
      if (await this.saveAndUpdate(false)) return;

      if (!this.handleValidate("purchaseMoviment")) return;
      await this.assignSavePurchaseAndProducts();
    },

    handleValidate(typeItem = "purchase") {
      const types = {
        purchase: () => ValidatePurchase(this.dataPurchase),
        purchaseMoviment: () => ValidatePurchaseMoviment(this.purchaseMoviment),
      };

      const invalidField =
        typeItem === "purchase"
          ? "invalidFieldsPurchase"
          : "invalidFieldsMoviment";

      return this.handleErrors(types[typeItem](), invalidField);
    },

    handleErrors(errors, typeValidate = "invalidFieldsPurchase") {
      console.log(errors);
      if (errors && errors.length) {
        errors.forEach((erro) => {
          this[typeValidate][erro.keyError] = "isInvalidInput";
        });

        this.$toast.open({
          message: "Existem campos obrigatórios!",
          type: "info",
        });

        return false;
      }

      return true;
    },

    clearInvalidFields(key, type = "invalidFieldsPurchase") {
      if (this[type][key]) this[type][key] = "";
    },

    sumValueTotal() {
      const totalofValor = this.productsListGrid.reduce(
        (oldValue, newValue) =>
          oldValue + newValue.valorUnitario * newValue.quantidade,
        0
      );
      this.amount = parseFloat(totalofValor).toLocaleString("pt-br", {
        style: "currency",
        currency: "BRL",
      });
    },

    async getAllSuppliers() {
      const selectedId = this.dataSearchFromPurchase.id
        ? this.dataSearchFromPurchase.idFornecedor
        : this.dataPurchase.id ? this.dataPurchase.idFornecedor : undefined;
      const result = await ServiceSupplier.fillComobobox(selectedId);
      this.allSupplier = result;
    },

    openModalImportXml() {
      this.$bvModal.show("modalImportXml");
      this.cfopSelect = this.dataPurchase.cfop;
    },
    clearPurchase() {
      this.dataPurchase = removeReference(INITIAL_STATE_PURCHASE);

      this.$refs.idFornecedor.valueItems = "";
      this.$refs.dataCompra.valueInput = "";

      this.productsListGrid = [];
      this.idSupplier = "";
      this.SET_DATA_SEARCH_FROM_PURCHASE({});
    },
    clearProducts() {
      this.purchaseMoviment = removeReference(INITIAL_STATE_PURCHASE_MOVIMENT);
      this.purchaseMoviment.nome = "";
      this.selectedProductName = "";

      this.purchaseMoviment.idCompra = this.dataPurchase.id
        ? this.dataPurchase.id
        : null;

      this.estoque = "";
      this.$refs.quantidade.valueInput = 1;
      this.$refs.valorUnitario.valueInput = "";
      this.$refs.estoque.valueInput = "";

      this.toggleClearSelect = !this.toggleClearSelect;
    },
    clearAll() {
      this.clearPurchase();
      this.clearProducts();

      this.invalidFieldsMoviment = removeReference(
        INVALID_FIELDS_PURCHASE_MOVIMENT
      );
      this.invalidFieldsPurchase = removeReference(INVALID_FIELDS_PURCHASE);
    },
    assingEdit() {
      this.productsListGrid = this.dataSearchFromPurchase.products;

      Reflect.deleteProperty(this.dataSearchFromPurchase, "products");

      Object.assign(this.dataPurchase, this.dataSearchFromPurchase);

      this.purchaseMoviment.idCompra = this.dataPurchase.id;

      this.$refs.refNop.valueItems = this.dataSearchFromPurchase.idNatureOp;
      this.$refs.dataCompra.valueInput = this.dataSearchFromPurchase.dataCompra;
      this.$refs.idFornecedor.valueItems =
        this.dataSearchFromPurchase.idFornecedor;

      this.sumValueTotal();
    },
    async assignSavePurchaseAndProducts() {
      try {
        if (this.purchaseMoviment.tipoProduto === "normal") {
          this.purchaseMoviment.nome =
            this.purchaseMoviment.nome || this.selectedProductName || "";
        }

        this.purchaseMoviment.idCompra = this.dataPurchase.id;

        await ServiceProductsPurchase.save(this.purchaseMoviment);

        this.$toast.open({
          message: "Produto adicionado!",
          type: "success",
        });

        await this.getProductsForGrid();
        this.clearProducts();
      } catch (error) {
        const message = error?.response?.data?.message;

        this.$toast.open({
          message: message || "Erro ao adicionar produto",
          type: "error",
        });

        const typeError = HandleErrors(
          error?.response?.data?.message === "Validation failed"
            ? error?.response?.data?.erros
            : error?.response?.data?.message
        );

        if (message && message.includes("NOT_ALLOWED"))
          this.$toast.open({
            message: message.split(":")[1],
            type: "info",
          });
        else if (typeError && Object.keys(typeError).length)
          this.$toast.open({
            message: typeError.message,
            type: "info",
          });
        else
          this.$toast.open({
            message: `${error.response.data.message}`,
            type: "warning",
          });

        return error;
      }
    },
    async getProductsForGrid() {
      const result = await ServiceProductsPurchase.getProductsForGrid(
        this.dataPurchase.id
      );

      this.productsListGrid = result;

      this.sumValueTotal();
    },
    async deleteProductOfPurchase(item) {
      try {
        await ServiceProductsPurchase.delete(item.idProduto, item.id);
        this.getProductsForGrid();
        return this.$toast.open({
          message: "Produto Excluido",
          type: "success",
        });
      } catch (error) {
        return this.$toast.open({
          message: "Opa, deu erro!",
          type: "error",
        });
      }
    },

    async searchPurchase(id) {
      return await ServicePurchase.findPurchaseById(id);
    },

    handleModalCreateProduct(nameModal, idProduct) {
      this.idProductFromSearch = idProduct;
      this.openModals(nameModal);
    },

    openModals(idModal) {
      this.$bvModal.show(idModal);
    },

    handleSelectTab(idxTab) {
      this.tabSelected = idxTab;

      this.clearProducts();

      this.purchaseMoviment.tipoProduto = !idxTab ? "normal" : "agrotoxico";
    },

    async selectProductSetDefaultValue(prod) {
      if (prod) {
        if (this.tabSelected) {
          this.selectedProductName = "";
          this.purchaseMoviment.nome = "";
          this.listEmbs =
            await ServiceCompendio.findAllEmbalagensByIdAgrotoxico(
              this.purchaseMoviment.agrotoxico.idAgrotoxico
            );

          this.purchaseMoviment.agrotoxico = {
            ...this.purchaseMoviment.agrotoxico,
            registroAgrotox: prod.registro,
            agrotoxico: prod.nome,
          };

          return;
        }

        const currencyValueProduct = prod.valorVenda.toLocaleString("pt-br", {
          minimumFractionDigits: 2,
        });

        this.selectedProductName = prod.nome || "";
        this.purchaseMoviment.nome = prod.nome || "";

        this.purchaseMoviment.valorUnitario = currencyValueProduct;
        this.$refs.valorUnitario.valueInput = currencyValueProduct;

        this.estoque = prod.estoque;
        this.$refs.estoque.valueInput = prod.estoque;
      }
    },

    async getAllNatures() {
      const result = await serviceNatureOps.fillComobobox();
      this.allNatures = result;
    },

    handleAssingEmb(emb) {
      this.purchaseMoviment.agrotoxico.embalagem =
        this.listEmbs.find((embItem) => embItem.descricao === emb)?.descricao || null;
    },
  },
  computed: {
    valorNfeFormatado() {
      return Number(this.dataPurchase.valorNfe ?? 0).toLocaleString("pt-br", {
        style: "currency",
        currency: "BRL",
      });
    },
    ...mapState({
      dataSearchFromPurchase: (state) => state.dataSearchFromPurchase,
    }),
  },

  mounted() {
    this.getAllSuppliers();
    this.getAllNatures();

    if (this.dataSearchFromPurchase.id) {
      this.assingEdit();
    }

    if (this.payloadFromDfe?.cfop) {
      this.cfopSelect = this.payloadFromDfe?.cfop;
      this.dataPurchase.cfop = this.payloadFromDfe?.cfop;
    }
  },

  watch: {
    idSupplier() {
      this.getAllSuppliers();
      this.dataPurchase.idFornecedor = this.idSupplier;
    },
    async modalIdForPurchase() {
      this.dataPurchase.id = this.modalIdForPurchase;
      await this.getProductsForGrid();

      const result = await this.searchPurchase(this.modalIdForPurchase);
      this.dataPurchase.dataCompra = result.dataCompra;
      this.dataPurchase.numeroNfe = result.numeroNfe;
      this.dataPurchase.modeloNfe = result.modeloNfe;
      this.dataPurchase.serieNfe = result.serieNfe;
      this.dataPurchase.chaveNfe = result.chaveNfe;
    },
    async dataEditPurchase() {
      Object.assign(this.dataPurchase, this.dataEditPurchase);
      await this.getProductsForGrid();
    },
  },

  beforeDestroy() {
    this.$emit("clearPayloadByDfe");
  },
};
</script>
<style scoped>
.BoxFront {
  display: flex;
  margin-left: 30px;
  width: calc(100% - 30px);
  height: 100vh;
  font-size: 12px;
}

.contentFront {
  width: 45%;
  height: auto;
  margin-left: 40px;
}

.selectPlus {
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 20px;
  align-items: center;
}

.borderInput {
  border-radius: 3px;
  height: 28px;
  border: 1px solid #d5d3d3;
}

.screenProducts {
  align-items: center;
  background: white;
  cursor: pointer;
  display: flex;
  width: 2em;
  height: 2em;
  justify-content: center;
}

.fixedSelect {
  position: absolute;
  font-size: 10px;
  bottom: 15px;
  left: 10px;
  background-color: #ffffff;
  padding: 0 0.4em;
}
.inputTotals input:hover {
  background: #d9d9d9 !important;
  border: 1px solid #262626;
}
.textarea:hover {
  background: #d9d9d9;
  border: 1px solid #262626;
}
.inputTextArea:hover {
  background: #d9d9d9;
  border: 1px solid #262626;
}
.borderInput {
  font-size: 16px;
  height: 30px;
  border: 1px solid #d5d3d3;
  border-radius: 5px;
  outline: none;
  transition: ease-in 0.1s all;
  padding-left: 5px;
  padding-right: 4px;
  color: #5c5855;
}

.input-group {
  width: 30%;
}

.rowContainer {
  border: 1px solid rgb(230, 230, 230);
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  padding: 10px 10px 5px 10px;
  background: #f9f9f94d;
  margin-bottom: 10px;
}

.rowContent {
  display: flex;
  width: 100%;
  padding: 10px 0 5px 0;
  justify-content: space-between;
  gap: 10px;
}

.alertModal {
  font-size: 11px;
  color: rgb(115, 0, 0);
  padding-left: 40px;
  margin: -15px;
}

.iconSelect {
  position: absolute;
  right: 0px !important;
  z-index: 10;
  background-color: #c1c1c1;
  color: whitesmoke;
  height: 30px;
  width: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0.25rem;
  cursor: pointer;
}

.rowObservation {
  display: flex;
  width: 100%;
  padding: 10px 0 5px 0;
  height: 40px;
  position: relative;
}

.input-group-ob {
  width: 100%;
}

.input-group {
  width: 30%;
}

.user-label-ob {
  position: absolute;
  margin-bottom: 0px;
  font-size: 11px;
  bottom: 22px;
  left: 11px;
  z-index: 2;
  text-transform: capitalize;
  color: rgb(85, 81, 81);
  background-color: white;
}

.input {
  font-size: 12px !important;
  width: 100%;
}

.input:focus ~ label,
input:valid ~ label {
  transform: translateY(-50%) scale(0.8);
  background-color: #ffffff;
  padding: 0 0.1em;
}

.user-label {
  position: absolute;
  left: 10px;
  font-size: 11px;
  bottom: 7px;
  pointer-events: none;
  transform: translateY(0.5rem);
  transition: 150ms cubic-bezier(0.4, 0, 0.2, 1);
  white-space: nowrap !important;
  text-overflow: ellipsis;
  color: #666360;
}

/* ----------------------------  */

.infoValue {
  display: flex;
  align-items: center;
}

.formFront {
  width: 95%;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-content: center;
  margin-top: 10px;
  gap: 20px;
}

.content-form-btn {
  display: flex;
  width: 94%;
  justify-content: flex-end;
}

.form-btn {
  position: relative;
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  background: #fbfbfb;
  border: 1px solid green;
  color: green;
  border-radius: 3px;
  width: auto;
  height: 28px;
  margin-top: 40px;
  box-shadow: 0px 1px 1px 0px black;
}

.form-btn:hover {
  border: 1px solid green;
  color: green;
  background: whitesmoke;
}

.contentSketch {
  width: 50%;
  border-left: 2px solid #d5d3d3;
  height: auto;
  position: relative;
}

.productsDesktop {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  padding: 0 30px;
  width: 100%;
  height: 55vh;
  max-height: 60vh;
  overflow-y: auto;
  overflow-x: hidden;
  text-align: center;
  background: #fffcfc;
}

.productsDesktop table {
  width: 100%;
}

.productsMobile {
  display: none;
}

.styleTotal {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 0 100px;
  background: #e3e9e6;
  font-size: 12px;
  height: 30px;
  font-weight: bold;
}

tbody {
  width: 100%;
  height: auto;
  max-height: 200px;
  overflow-y: auto;
}

tr:nth-child(even) {
  background: white;
}

tr {
  background: #fffcfc;
}

.rowProduct {
  width: 100%;
  height: 30px;
  border-bottom: 1px solid #f1efef;
}

.trashDelete {
  color: red;
  cursor: pointer;
}

.closeModal {
  position: absolute;
  top: 5px;
  right: 5px;
  z-index: 1000;
  color: rgb(255, 153, 153);
  cursor: pointer;
  border: 1px solid rgb(238, 238, 238);
  padding: 2px 3px;
  border-radius: 4px;
}

.closeModal:hover {
  color: red;
  background: rgba(245, 245, 245, 0.764);
}

.sketch-btn {
  position: relative;
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  background: rgb(255, 255, 255);
  border: 1px solid green;
  color: green;
  border-radius: 3px;
  width: 180px;
  height: 28px;
  margin-top: 90px;
  gap: 10px;
  box-shadow: 0px 1px 1px 0px black;
}

.sketch-btn:hover {
  background: whitesmoke;
  border: 1px solid green;
  color: green;
}

.content-sketch-btn {
  bottom: 50px;
  position: relative;
  display: flex;
  justify-content: space-evenly;
}

@media screen and (max-width: 900px) {
  .BoxFront {
    display: flex;
    margin-left: 0;
    width: 100%;
    height: auto;
    min-height: 100vh;
    font-size: 12px;
    flex-direction: column;
    padding: 12px;
    gap: 12px;
    box-sizing: border-box;
    background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 50%, #f8fafc 100%);
    padding-bottom: calc(160px + env(safe-area-inset-bottom)) !important;
  }

  .contentFront {
    width: 100%;
    height: auto;
    margin-left: 0;
    padding: 14px;
    border-radius: 14px;
    background: linear-gradient(135deg, #ffffff 0%, #f8fffe 100%);
    border: 1px solid rgba(0, 98, 86, 0.1);
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.06);
    box-sizing: border-box;
    position: relative;
    z-index: 1;
    padding-bottom: calc(160px + env(safe-area-inset-bottom)) !important;
  }

  .contentSketch {
    width: 100%;
    border: none;
    padding: 14px;
    border-radius: 14px;
    background: linear-gradient(135deg, #ffffff 0%, #f8fffe 100%);
    border: 1px solid rgba(0, 98, 86, 0.1);
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.06);
    box-sizing: border-box;
    overflow: visible;
    position: relative;
    z-index: 1;
    padding-bottom: calc(160px + env(safe-area-inset-bottom)) !important;
  }

  .form-btn {
    width: 100%;
    min-height: 48px;
    height: 48px;
    margin-top: 12px;
    border-radius: 12px;
    font-size: 15px;
    font-weight: 600;
    box-shadow: 0 3px 10px rgba(0, 98, 86, 0.2);
  }

  .sketch-btn {
    min-height: 48px;
    height: 48px;
    margin-top: 0;
    border-radius: 12px;
    font-size: 15px;
    font-weight: 600;
    width: 100%;
    box-shadow: 0 3px 10px rgba(0, 98, 86, 0.2);
  }

  .content-sketch-btn {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 2000;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    padding: 10px 12px calc(12px + env(safe-area-inset-bottom));
    background: rgba(255, 255, 255, 0.9);
    backdrop-filter: blur(8px);
    border-top: 1px solid rgba(0, 98, 86, 0.15);
  }

  .formFront {
    width: 100%;
    align-content: stretch;
    gap: 12px;
  }

  .content-form-btn {
    width: 100%;
    justify-content: stretch;
  }

  .rowContent,
  .selectPlus,
  .rowObservation,
  .styleTotal {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: flex-start;
    gap: 12px;
    width: 100%;
    height: auto;
    padding: 0;
  }

  .styleTotal {
    background: #e3e9e6;
    border-radius: 10px;
    padding: 12px;
    gap: 8px;
  }

  .input-group,
  .input-group-ob {
    width: 100%;
    min-width: 0;
    display: flex;
    flex-direction: column-reverse;
    gap: 6px;
    position: relative;
    z-index: 1;
  }

  .fixedSelect,
  .user-label,
  .user-label-ob {
    position: static;
    transform: none;
    left: auto;
    bottom: auto;
    margin: 0;
    font-size: 12px;
    font-weight: 600;
    color: #374151;
    background: transparent;
    padding: 0;
    pointer-events: auto;
    z-index: 1 !important;
  }

  .floating-label,
  .formFront .user-label,
  .formFront .user-label-ob {
    z-index: 1 !important;
  }

  .input:focus ~ label,
  input:valid ~ label {
    transform: none;
    background: transparent;
    padding: 0;
  }

  .borderInput,
  .input,
  input,
  select,
  textarea,
  .form-control,
  .form-control-sm {
    font-size: 16px !important;
    min-height: 44px;
    height: 44px;
    border-radius: 12px;
    width: 100%;
    box-sizing: border-box;
  }

  .input {
    padding-left: 12px;
    padding-right: 12px;
  }

  .alertModal {
    margin: 0;
    padding-left: 0;
    font-size: 12px;
    line-height: 1.4;
  }

  .productsDesktop {
    display: none;
  }

  .productsMobile {
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 8px;
    max-height: 50vh;
    overflow-y: auto;
    overflow-x: hidden;
  }

  .productCard {
    background: rgba(255, 255, 255, 0.95);
    border: 1px solid rgba(0, 98, 86, 0.15);
    border-radius: 12px;
    padding: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
    overflow: hidden;
    transition: all 0.2s ease;
  }

  .productCard:hover {
    box-shadow: 0 4px 12px rgba(0, 98, 86, 0.12);
    border-color: rgba(0, 98, 86, 0.25);
  }

  .productHeader {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 10px;
    margin-bottom: 10px;
  }

  .productName {
    font-weight: 700;
    font-size: 14px;
    line-height: 1.3;
    color: #111827;
    white-space: normal;
    overflow-wrap: break-word;
    word-break: normal;
    flex: 1;
  }

  .productMeta {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    margin-top: 10px;
  }

  .metaItem {
    display: flex;
    flex-direction: column;
    gap: 2px;
  }

  .metaLabel {
    font-size: 11px;
    font-weight: 700;
    color: #374151;
    text-transform: uppercase;
    letter-spacing: 0.3px;
  }

  .metaValue {
    font-size: 14px;
    font-weight: 600;
    color: #111827;
  }

  .productFooter {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 10px;
    padding-top: 10px;
    border-top: 1px solid rgba(0, 98, 86, 0.12);
  }

  .productFooter .metaLabel {
    font-size: 12px;
  }

  .productFooter .metaValue {
    font-size: 15px;
    font-weight: 700;
    color: #059669;
  }

  .emptyList {
    padding: 24px 12px;
    text-align: center;
    color: #6b7280;
    font-weight: 600;
    font-size: 14px;
  }

  .contentFront p,
  .contentSketch p {
    margin-bottom: 12px;
  }

  .formFront > div[style*="display: flex"] {
    flex-direction: column !important;
    align-items: stretch !important;
  }

  .formFront > div[style*="width: 250px"] {
    width: 100% !important;
  }

  .rowContent > *,
  .rowObservation > * {
    width: 100% !important;
    max-width: 100%;
  }
}

@media screen and (max-width: 700px) {
  .content-sketch-btn {
    grid-template-columns: 1fr;
  }

  .tableProducts {
    padding: 10px;
  }
}
</style>
